/* global document */
import { useSyncExternalStore } from "react";

// Tracks whether the pointer is currently over the document body. This is global
// state shared by every cell, so a single document-level listener is attached
// regardless of how many components subscribe — instead of one pair of listeners
// per cell, which made every mouse move fire hundreds of handlers.

let mouseOver = false;
const listeners = new Set();
let attached = false;

function notify() {
  listeners.forEach((l) => l());
}

function handleMouseMove() {
  if (!mouseOver) {
    mouseOver = true;
    notify();
  }
}

function handleMouseLeave() {
  if (mouseOver) {
    mouseOver = false;
    notify();
  }
}

function subscribe(listener) {
  listeners.add(listener);
  if (!attached && typeof document !== "undefined") {
    document.body.addEventListener("mousemove", handleMouseMove);
    document.body.addEventListener("mouseleave", handleMouseLeave);
    attached = true;
  }
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && attached && typeof document !== "undefined") {
      document.body.removeEventListener("mousemove", handleMouseMove);
      document.body.removeEventListener("mouseleave", handleMouseLeave);
      attached = false;
    }
  };
}

function getSnapshot() {
  return mouseOver;
}

function getServerSnapshot() {
  return false;
}

export function useMouseOverDocument() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
